import { DEFAULT_MULTIPLIER, IMAGE_ASSETS } from '../Enums/ImageAssets';
import './Components.scss';

function ImageAsset(props: {
  name: string,
  multiplier?: number

  // props below should be moved to <button> or some other component, which uses ImageAsset
  onClick?: any,
  disabled?: boolean,
  showPointerOnHover?: boolean
}) {

  const asset = IMAGE_ASSETS[props.name] || null;

  if (!asset) {
    console.warn(props.name + ' asset is missing');
    return <></>;
  }

  const multiplier = props.multiplier || DEFAULT_MULTIPLIER;

  function handleClick() {
    if (props.onClick) {
      props.onClick()
    }
  }

  return (
    <img className={`asset ${props.showPointerOnHover ? 'show-pointer' : ''} ${props.disabled ? 'disabled' : ''}`}
      width={asset.width * multiplier}
      height={asset.height * multiplier}
      src={props.name}
      onClick={handleClick}
    />
  );
}

export default ImageAsset;
